import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getSurmountAccountCashTransfer } from "../service";

export const useSurmountTransactions = () => {
  const { data, isLoading, fetchNextPage, isFetchingNextPage, refetch } =
    useInfiniteQuery({
      queryKey: ["surmountTransactions"],
      queryFn: async ({ pageParam = 1 }) => {
        const params = {
          page: pageParam,
          size: 10,
        };

        const response = await getSurmountAccountCashTransfer(params);
        return {
          data: response.data,
          currentPage: response?.page,
          totalPages: response?.total_pages,
          totalCount: response?.total_count,
        };
      },
      getNextPageParam: (lastPage) => {
        const currentPage = Number(lastPage.currentPage);
        const totalPages = Number(lastPage.totalPages);
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
    });

  const allTransactions = data?.pages?.flatMap((page) => page.data) || [];

  return {
    transactions: allTransactions,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    refetch,
  };
};
